
import Select from "react-select";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import Checkvutregister from "./checkvut/checkvutregister";
import { MDBCol, MDBRow } from "mdbreact";

function Register1() {
  const [major, setMajor] = useState(null);
  const [kruFile, setKruFile] = useState(false);
  const options = [
    // { value: "8101", label: "การบริหารการศึกษา" },
    // โท { value: "8102", label: "ยุทธศาสตร์การบริหารและการพัฒนา" },
    { value: "8103", label: "การจัดการสมัยใหม่" },
    // เอก  { value: "8201", label: "การบริหารการศึกษา" },
    // { value: "8202", label: "ยุทธศาสตร์การบริหารและการพัฒนา" },
  ];
  useEffect(() => {
    axios
      .get("https://admission.kpru.ac.th/admission2017/student/showCourseBundit")
      .then((res) => {});
  }, []);
  const handleChange = (selectedOption) => {
    setMajor(selectedOption.value);
    if (selectedOption.label === "การบริหารการศึกษา") {
      setKruFile(true);
    } else {
      setKruFile(false);
    }
  };
  return (
    <div className="container-fluid pt-4">
      <MDBRow className="justify-content-center ">
        <MDBCol size="6">
          <label htmlFor="select-major" for="select-major">
            เลือกสาขาที่ต้องการเข้าศึกษา
          </label>
          <Select
            options={options}
            onChange={handleChange}
            placeholder="-----ระบุสาขา------"
          />
        </MDBCol>
      </MDBRow>
      <div className={kruFile? "d-block":"d-none"} >
        <MDBRow className="justify-content-center mt-2 ">
          <MDBCol size="6">

          </MDBCol>
     
        </MDBRow>
        <MDBRow className="justify-content-center mt-2 ">
          <MDBCol size="6">* อัพโหลดหลักฐานเพิ่มเติม</MDBCol>
        </MDBRow>
      </div>

      <MDBRow className="justify-content-center ">
        <MDBCol size="6">
          <div className="btn btn-info w-100 m-0 mt-2">ยืนยัน</div>
        </MDBCol>
      </MDBRow>
    </div>
  );
}

export default Register1;
